(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7bbe"];
var parcelRegister = parcelRequire.register;
parcelRegister("48ipu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $29a21b361d480ed2$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $515ZP = parcelRequire("515ZP");

var $exvWl = parcelRequire("exvWl");

const $29a21b361d480ed2$var$Form = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("k1S1i")));

const $29a21b361d480ed2$var$FormInput = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("4ZL4c")));
const $29a21b361d480ed2$var$ssnFormDataDefaultValues = {
    ssn: "",
    firstName: "",
    zipCode: "",
    address: "",
    city: "",
    lastName: "",
    email: "",
    phone: ""
};
function $29a21b361d480ed2$export$2e2bcd8739ae039({ children: children, form: form, postUrl: postUrl, novalidate: novalidate, setDisableSubmit: setDisableSubmit, labelOnBg: labelOnBg }) {
    const ssnNumberForm = (0, $exvWl.useForm)();
    const [formValues, setFormValues] = (0, $dTCkE.useState)($29a21b361d480ed2$var$ssnFormDataDefaultValues);
    const [disableEdit, setDisableEdit] = (0, $dTCkE.useState)(false);
    const [disableEditFirstName, setDisableEditFirstName] = (0, $dTCkE.useState)(false);
    const [disableEditLastName, setDisableEditLastName] = (0, $dTCkE.useState)(false);
    const [disableEditAddress, setDisableEditAddress] = (0, $dTCkE.useState)(false);
    const [disableEditZipCode, setDisableEditZipCode] = (0, $dTCkE.useState)(false);
    const [disableEditCity, setDisableEditCity] = (0, $dTCkE.useState)(false);
    const [showError, setError] = (0, $dTCkE.useState)(false);
    const [ssnResult, setSsnResult] = (0, $dTCkE.useState)();
    function hasAsterisk(obj) {
        let includedAsterisk = false;
        for(const key in obj)if (obj[key]?.includes("*")) {
            setDisableSubmit(true);
            if (key === "firstName") form.setError("fname", {
                type: "custom",
                message: "Ange ett giltigt namn"
            });
            else if (key === "lastName") form.setError("lname", {
                type: "custom",
                message: "Ange ett giltigt namn"
            });
            else if (key === "address") form.setError("street-address", {
                type: "custom",
                message: "Ange en gilting adress"
            });
            else if (key === "zipCode") form.setError("postal-code", {
                type: "custom",
                message: "Ange ett giltigt v\xe4rde"
            });
            else if (key === "city") form.setError("cityVisible", {
                type: "custom",
                message: "Ange en giltig postort"
            });
            includedAsterisk = true;
        }
        return includedAsterisk;
    }
    function modifyStr(stringItem) {
        var str = stringItem;
        var modifiedStr = str.replace(/^(.)(.*)(.)$/, function(match, firstLetter, middleLetters, lastLetter) {
            var asterisks = "*".repeat(middleLetters.length);
            return firstLetter + asterisks + lastLetter;
        });
        return modifiedStr;
    }
    async function fetchSsn() {
        if (!formValues.ssn) {
            setError(true);
            return;
        }
        let fetchValues = formValues.ssn.replace("-", "");
        if (fetchValues.length === 10) {
            const values = fetchValues.slice(0, 1);
            if (values == "0" || values == "1") fetchValues = "20" + fetchValues;
            else fetchValues = "19" + fetchValues;
        }
        const ssnDetailsResp = await (0, $515ZP.getPersonalData)(fetchValues);
        if (!ssnDetailsResp.address && !ssnDetailsResp.city && !ssnDetailsResp.firstName && !ssnDetailsResp.lastName && !ssnDetailsResp.zipCode) {
            setError(true);
            return;
        } else {
            form.clearErrors();
            setDisableSubmit(false);
            setError(false);
            setDisableEdit(true);
            if (ssnDetailsResp.firstName) setDisableEditFirstName(true);
            if (ssnDetailsResp.lastName) setDisableEditLastName(true);
            if (ssnDetailsResp.address) setDisableEditAddress(true);
            if (ssnDetailsResp.zipCode) setDisableEditZipCode(true);
            if (ssnDetailsResp.city) setDisableEditCity(true);
            setFormValues({
                ...formValues,
                ...ssnDetailsResp
            });
            setSsnResult(ssnDetailsResp);
            form.setValue("firstname", ssnDetailsResp?.firstName);
            form.setValue("fname", modifyStr(ssnDetailsResp?.firstName));
            form.setValue("lastname", ssnDetailsResp?.lastName);
            form.setValue("lname", modifyStr(ssnDetailsResp?.lastName));
            form.setValue("Address", ssnDetailsResp?.address);
            form.setValue("street-address", modifyStr(ssnDetailsResp?.address));
            form.setValue("city", ssnDetailsResp?.city);
            form.setValue("cityVisible", modifyStr(ssnDetailsResp?.city));
            form.setValue("zipCode", ssnDetailsResp?.zipCode);
            form.setValue("postal-code", modifyStr(ssnDetailsResp?.zipCode));
        }
    }
    function clearValues() {
        form.setValue("firstname", "");
        form.setValue("fname", "");
        formValues.firstName = "";
        form.setValue("lastname", "");
        form.setValue("lname", "");
        formValues.lastName = "";
        form.setValue("Address", "");
        form.setValue("street-address", "");
        formValues.address = "";
        form.setValue("city", "");
        form.setValue("cityVisible", "");
        formValues.city = "";
        form.setValue("zipCode", "");
        form.setValue("postal-code", "");
        formValues.zipCode = "";
    }
    (0, $dTCkE.useEffect)(()=>{
        form.setValue("firstname", formValues?.firstName);
        if (disableEditFirstName) form.setValue("fname", modifyStr(formValues?.firstName));
        else {
            form.setValue("fname", formValues?.firstName);
            if (formValues?.firstName.indexOf("*") == -1) form.clearErrors("fname");
        }
    }, [
        formValues?.firstName
    ]);
    (0, $dTCkE.useEffect)(()=>{
        form.setValue("lastname", formValues?.lastName);
        if (disableEditLastName) form.setValue("lname", modifyStr(formValues?.lastName));
        else {
            form.setValue("lname", formValues?.lastName);
            if (formValues?.lastName.indexOf("*") == -1) form.clearErrors("lname");
        }
    }, [
        formValues?.lastName
    ]);
    (0, $dTCkE.useEffect)(()=>{
        form.setValue("Address", formValues?.address);
        if (disableEditAddress) form.setValue("street-address", modifyStr(formValues?.address));
        else {
            form.setValue("street-address", formValues?.address);
            if (formValues?.address.indexOf("*") == -1) form.clearErrors("street-address");
        }
    }, [
        formValues?.address
    ]);
    (0, $dTCkE.useEffect)(()=>{
        form.setValue("city", formValues?.city);
        if (disableEditCity) form.setValue("cityVisible", modifyStr(formValues?.city));
        else {
            form.setValue("cityVisible", formValues?.city);
            if (formValues?.city.indexOf("*") == -1) form.clearErrors("cityVisible");
        }
    }, [
        formValues?.city
    ]);
    (0, $dTCkE.useEffect)(()=>{
        form.setValue("zipCode", formValues?.zipCode);
        if (disableEditZipCode) form.setValue("postal-code", modifyStr(formValues?.zipCode));
        else {
            form.setValue("postal-code", formValues?.zipCode);
            if (formValues?.zipCode.indexOf("*") == -1) form.clearErrors("postal-code");
        }
    }, [
        formValues?.zipCode
    ]);
    (0, $dTCkE.useEffect)(()=>{
        if (!disableEdit && !hasAsterisk(formValues)) setDisableSubmit(false);
    }, [
        formValues
    ]);
    return /*#__PURE__*/ (0, $a9eYm.jsxs)((0, $a9eYm.Fragment), {
        children: [
            /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                children: /*#__PURE__*/ (0, $a9eYm.jsx)($29a21b361d480ed2$var$Form, {
                    form: ssnNumberForm,
                    postUrl: `/PersonData/GetPersonInformation?SSN=${formValues.ssn}`,
                    novalidate: novalidate,
                    children: /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                        className: "md:flex md:flex-wrap ssn-form-input",
                        children: [
                            /*#__PURE__*/ (0, $a9eYm.jsx)($29a21b361d480ed2$var$FormInput, {
                                placeholder: "Personnummer",
                                label: "Personnummer (\xc5\xc5\xc5\xc5MMDDXXXX)",
                                name: "ssn",
                                type: "text",
                                controller: {
                                    value: formValues.ssn,
                                    setValue: (ssn)=>setFormValues({
                                            ...formValues,
                                            ssn: ssn
                                        })
                                },
                                labelOnBg: labelOnBg
                            }),
                            /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                                className: "relative md:my-3 mt-4 mb-0 md:px-2 md:w-1/2",
                                children: [
                                    /*#__PURE__*/ (0, $a9eYm.jsx)("button", {
                                        className: "inset-shadow border-1 px-5 py-3 md:py-[.9rem] hover-blue-border border-blue700 rounded-md w-full font-icb text-blue700 transform duration-200 cursor-pointer",
                                        type: "button",
                                        onClick: fetchSsn,
                                        disabled: !formValues.ssn,
                                        children: "H\xe4mta uppgifter automatiskt"
                                    }),
                                    showError === true && /*#__PURE__*/ (0, $a9eYm.jsx)("p", {
                                        className: "right-0 md:absolute m-0 px-2 pt-2 text-red500 text-tiny",
                                        children: "Fyll i ett korrekt personnummer"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                className: "mdplus:mx-2 mt-3 mdplus:mt-0",
                children: /*#__PURE__*/ (0, $a9eYm.jsx)("a", {
                    href: "/integritetspolicy",
                    target: "_blank",
                    className: "text-blue700 underline",
                    children: "L\xe4s om hur vi behandlar dina uppgifter"
                })
            }),
            /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                className: "flex items-center mdplus:mx-2 my-4 mt-5",
                children: [
                    /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                        className: "flex-1 border-grey100 border-t-2 w-1/2"
                    }),
                    /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                        className: "mx-8 font-ic text-grey300",
                        children: "eller"
                    }),
                    /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                        className: "flex-1 border-grey100 border-t-2 w-1/2"
                    })
                ]
            }),
            ssnResult && disableEdit === true && /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                className: "ml-2 pb-2 md:pb-3",
                children: /*#__PURE__*/ (0, $a9eYm.jsx)("button", {
                    className: "block md:inline-block md:ml-2 font-icb align-text-top text-blue700 edit-btn",
                    onClick: ()=>{
                        setDisableEdit(false);
                        setDisableEditFirstName(false);
                        setDisableEditLastName(false);
                        setDisableEditAddress(false);
                        setDisableEditCity(false);
                        setDisableEditZipCode(false);
                        clearValues();
                    },
                    children: "Ta bort och fyll i uppgifterna sj\xe4lv"
                })
            }),
            /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                children: /*#__PURE__*/ (0, $a9eYm.jsx)($29a21b361d480ed2$var$Form, {
                    form: form,
                    postUrl: postUrl,
                    novalidate: novalidate,
                    children: /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                        className: "md:flex md:flex-wrap",
                        children: [
                            /*#__PURE__*/ (0, $a9eYm.jsx)($29a21b361d480ed2$var$FormInput, {
                                placeholder: "F\xf6rnamn*",
                                label: "F\xf6rnamn*",
                                name: "fname",
                                disabled: !ssnResult?.firstName ? false : disableEdit,
                                required: true,
                                controller: {
                                    value: formValues.firstName,
                                    setValue: (firstName)=>setFormValues({
                                            ...formValues,
                                            firstName: firstName
                                        })
                                },
                                labelOnBg: labelOnBg
                            }),
                            /*#__PURE__*/ (0, $a9eYm.jsx)($29a21b361d480ed2$var$FormInput, {
                                placeholder: "Efternamn*",
                                label: "Efternamn*",
                                name: "lname",
                                required: true,
                                disabled: !ssnResult?.lastName ? false : disableEdit,
                                controller: {
                                    value: formValues.lastName,
                                    setValue: (lastName)=>setFormValues({
                                            ...formValues,
                                            lastName: lastName
                                        })
                                },
                                labelOnBg: labelOnBg
                            }),
                            /*#__PURE__*/ (0, $a9eYm.jsx)($29a21b361d480ed2$var$FormInput, {
                                placeholder: "Gatuadress*",
                                label: "Gatuadress*",
                                name: "street-address",
                                required: true,
                                disabled: !ssnResult?.address ? false : disableEdit,
                                controller: {
                                    value: formValues.address,
                                    setValue: (address)=>setFormValues({
                                            ...formValues,
                                            address: address
                                        })
                                },
                                labelOnBg: labelOnBg
                            }),
                            /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                                className: "md:flex md:w-1/2",
                                children: [
                                    /*#__PURE__*/ (0, $a9eYm.jsx)($29a21b361d480ed2$var$FormInput, {
                                        placeholder: "Postnummer*",
                                        label: "Postnummer*",
                                        name: "postal-code",
                                        pattern: /^[0-9 *]{5,6}$/,
                                        required: true,
                                        disabled: !ssnResult?.zipCode ? false : disableEdit,
                                        controller: {
                                            value: formValues.zipCode,
                                            setValue: (zipCode)=>setFormValues({
                                                    ...formValues,
                                                    zipCode: zipCode
                                                })
                                        },
                                        labelOnBg: labelOnBg
                                    }),
                                    /*#__PURE__*/ (0, $a9eYm.jsx)($29a21b361d480ed2$var$FormInput, {
                                        placeholder: "Postort*",
                                        label: "Postort*",
                                        name: "cityVisible",
                                        pattern: /^[A-Za-zÅÄÖåäö *-]{2,20}$/,
                                        required: true,
                                        disabled: !ssnResult?.city ? false : disableEdit,
                                        controller: {
                                            value: formValues.city,
                                            setValue: (city)=>setFormValues({
                                                    ...formValues,
                                                    city: city
                                                })
                                        },
                                        labelOnBg: labelOnBg
                                    }),
                                    /*#__PURE__*/ (0, $a9eYm.jsx)($29a21b361d480ed2$var$FormInput, {
                                        name: "firstname",
                                        type: "hidden",
                                        placeholder: ""
                                    }),
                                    /*#__PURE__*/ (0, $a9eYm.jsx)($29a21b361d480ed2$var$FormInput, {
                                        placeholder: "",
                                        name: "lastname",
                                        type: "hidden"
                                    }),
                                    /*#__PURE__*/ (0, $a9eYm.jsx)($29a21b361d480ed2$var$FormInput, {
                                        placeholder: "",
                                        name: "Address",
                                        type: "hidden"
                                    }),
                                    /*#__PURE__*/ (0, $a9eYm.jsx)($29a21b361d480ed2$var$FormInput, {
                                        placeholder: "",
                                        name: "zipCode",
                                        type: "hidden"
                                    }),
                                    /*#__PURE__*/ (0, $a9eYm.jsx)($29a21b361d480ed2$var$FormInput, {
                                        placeholder: "",
                                        name: "city",
                                        type: "hidden"
                                    })
                                ]
                            }),
                            children
                        ]
                    })
                })
            })
        ]
    });
}

});
parcelRegister("k1S1i", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("cCZ7C")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("a6BV3"))
]).then(()=>parcelRequire("a6GFB"));

});

parcelRegister("4ZL4c", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("hbeiW")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("4G055")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("7KCxG")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("jc4ur"))
]).then(()=>parcelRequire("oPeBr"));

});


})();
//# sourceMappingURL=FormWithSsnData.fba8ca87.js.map
